// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { SubmissionError } from 'redux-form'
import { loadingToggler } from 'redux/modules/loading'
import { setRcn } from 'redux/modules/protection/actions'
import {
  assembleQuery,
  fetchWrapper,
} from 'helpers/api'

// redux-form submit handler

const getRcn = formValues => (dispatch, getState) => (
  dispatch(loadingToggler(
    async () => {
      const {
        selectInput,
        textInput,
      } = formValues

      const query = assembleQuery([{
        field: selectInput,
        value: textInput,
      }])

      try {
        const res = await fetchWrapper(`/rcn${query}`)
        // since we have no unique value to rely upon when rendering this data,
        // store a static unique key so react can optimize rendering/sorting/etc
        res.forEach((d, i) => {
          d.uniqueKey = i
        })

        dispatch(setRcn(res))
      } catch (err) {
        console.warn(err)
        dispatch(setRcn([]))
        throw new SubmissionError({
          _error: err.message || 'Uncaught Error!',
        })
      }
    })
  )
)

export default getRcn
